import { useEffect } from 'react';
import { connect } from 'react-redux';

// models
import { StateModel } from '../core/models/state.model';
import { ClientModel } from '../core/models/client.model';

// componets
import NavLeft from '../components/NavLeft';

// utils
import { logPageView } from '../utils/firebaseConfig';

interface AvisoProps {
	client: ClientModel;
}

function Aviso({ client }: AvisoProps) {
	useEffect(() => {
		logPageView('Terms and Conditions', client);
	}, []);

	return (
		<>
			<NavLeft name='Aviso Privacidad' />
			<section className='sumasix-aviso mt-8'>
				<h1 className='text-center text-primary'>
					Aviso de Privacidad de Datos
				</h1>
				<br />
				<p>
					Mediante el presente Aviso de Privacidad (en adelante el “Aviso”), y
					en atención a las disposiciones contenidas en la Ley Federal de
					Protección de Datos Personales en Posesión de los Particulares, su
					Reglamento y disposiciones relacionadas vigentes en México (en
					conjunto, la “Ley”), se describen los términos en los que se
					obtendrán, usarán, divulgarán o almacenarán (en adelante, cualquiera
					de dichas acciones en lo individual o en conjunto, el “Tratamiento”)
					los Datos Personales (según se define más adelante) que tú (el
					“Titular”) por cualquier medio nos proporciones.
				</p>
				<p>
					Controladora de Negocios Comerciales, S.A. de C.V. (“SUMA SIX” o
					“nosotros”, indistintamente) quien señala como domicilio para todos
					los efectos y obligaciones relacionadas con el presente Aviso el
					ubicado en Avenida Alfonso Reyes número 2202 Norte, en la Colonia
					Bellavista en la ciudad de Monterrey, Nuevo León, Código Postal 64410.
				</p>
				<p>
					En SUMA SIX estamos comprometidos en proteger la privacidad de los
					Titulares; el término “Titular(es)” se refiere a cualquier persona
					física que por cualquier medio le proporcione a SUMA SIX uno o varios
					de sus Datos Personales para los fines señalados más adelante.
				</p>
				<p>
					En el presente Aviso se describe cómo realizaremos el Tratamiento y
					protegemos tus Datos Personales.
				</p>
				<p>
					1. <br /> Fines para los cuales Tratamos tus Datos Personales.
				</p>
				<p>
					Recolectaremos una amplia variedad de información concerniente a tu
					persona, (dicha información, los “Datos Personales”). Las finalidades
					para las cuales utilizamos esta información se mencionan más adelante.
					En caso de que tratemos tu información para fines distintos, te lo
					informaremos en el momento correspondiente.
				</p>
				<p>
					1.1 Identificación y mayoría de edad. Esta finalidad se refiere a la
					confirmación de la identidad del Titular, según sea necesario para dar
					cumplimiento a las finalidades previstas en el presente Aviso, para
					tener control de acceso a nuestras instalaciones, seguridad de las
					mismas y de las y los visitantes (para lo cual tu foto o video puede
					ser tratado por nosotros), así como para verificar, en su caso, la
					mayoría de edad del Titular previo a su ingreso a cualquiera de las
					páginas, aplicaciones y plataformas oficiales de Internet de SUMA SIX
					y/o a su participación en las actividades promocionadas u organizadas
					por éste último, ya sea de forma presencial o en línea.
				</p>
				<p>
					1.2 Ofrecimiento de productos y servicios. Esta finalidad hace
					referencia a diversas actividades que realiza SUMA SIX, con el fin de
					ofrecer, comercializar, personalizar y mejorar nuestros productos y
					servicios, celebrar, mantener y ejecutar una relación comercial y/o de
					negocios con el Titular, la creación, actualización y manejo de la
					cuenta del Titular en nuestras páginas de Internet, plataformas y
					aplicaciones oficiales, así como la administración y proceso de pagos,
					operaciones y transacciones de los Titulares en las mismas.
				</p>
				<p>
					1.3 Mantener y optimizar nuestras páginas web, plataformas y
					aplicaciones oficiales. Esta finalidad incluye los casos en los que
					debamos resolver problemas de desempeño de nuestras aplicaciones,
					plataformas y páginas oficiales de Internet, incluyendo solución de
					problemas (troubleshooting), análisis de datos, pruebas, mantenimiento
					de sistemas, soporte, reportes y almacenamiento de datos, mejora de la
					disponibilidad de nuestras páginas web, plataformas y aplicaciones
					oficiales, y protegerlas contra cualquier tipo de fraude o mal uso.
				</p>
				<p>
					1.4 Uso de Datos Personales para el Envío de Mensajes SMS: Los datos
					personales que recabamos, tales como número de teléfono móvil, serán
					utilizados con la finalidad de enviar mensajes de texto (SMS)
					relacionados con actualizaciones de nuestros servicios, notificaciones
					importantes y/o promociones especiales. El uso de sus datos para estas
					finalidades se llevará a cabo conforme a las disposiciones de la Ley
					Federal de Protección de Datos Personales en Posesión de los
					Particulares y podrá ser revocado en cualquier momento mediante el
					ejercicio de sus derechos ARCO, siguiendo el procedimiento descrito en
					este aviso.
				</p>
				<p>
					1.5 Cumplimiento con la Ley. Esta finalidad hace referencia al
					Tratamiento de Datos Personales de los Titulares según sea necesario
					para realizar una actividad tendiente a dar cumplimiento a una
					obligación o requerimiento legal, o a una recomendación de autoridad
					de la cual SUMA SIX, incluyendo la revelación de Datos Personales a
					autoridades de gobierno o supervisoras, tales como autoridades
					fiscales, administrativas y/o judiciales.
					<br />
					Adicionalmente, utilizaremos tus Datos Personales para las siguientes
					finalidades no necesarias:
				</p>
				<p>
					1.6 Servicio al cliente. Esta finalidad incluye actividades tales como
					atender y dar seguimiento a las dudas, quejas o comentarios del
					Titular en relación con nuestros productos y/o servicios, motivo por
					el cual pudieran grabarse las llamadas telefónicas, correos
					electrónicos o cualquier tipo de comunicación entre el Titular y SUMA
					SIX, para extender invitaciones a eventos o hacer sugerencias de
					nuestros diversos productos y servicios que pudieran interesarte o de
					los cuales pudieras beneficiarte, así como para evaluar la calidad de
					nuestros productos y/o servicios y realizar encuestas de satisfacción.
				</p>
				<p>
					1.7 Análisis y estadísticas. Esta finalidad hace referencia a la
					elaboración de registros, reportes y estadísticas relacionadas a la
					información obtenida por cualquier medio, con el fin de mejorar
					nuestros productos y servicios, mercadotecnia, relaciones con clientes
					y experiencias.
				</p>
				<p>
					1.8 Perfiles de mercadotecnia. Esta finalidad refiere a las
					actividades que realizamos para mejorar nuestras estrategias de
					mercadotecnia, mediante la creación de una audiencia basada en
					segmentos de perfiles con el fin de enviarles ofertas y contenidos a
					su medida, particularmente, cuando utilizamos plataformas de manejo de
					Datos Personales o recibimos Datos Personales de plataformas de redes
					sociales. Los Datos utilizados para estos fines podrán ser encriptados
					y vueltos a descodificar, directamente por nosotros o a través de
					terceros.
				</p>
				<p>
					1.9 Publicidad y mercadotecnia. Esta finalidad hace referencia a
					actividades tales como el envío de información publicitaria sobre
					nuestros productos, desarrollo y envío de campañas de mercadotecnia o
					publicidad para ofrecer productos y/o servicios de SUMA SIX, sus
					filiales, subsidiarias y/o socios comerciales.
				</p>
				<p>
					En caso de que no desees que tus Datos Personales sean Tratados para
					las finalidades no necesarias, puedes desde este momento enviar un
					correo electrónico a la dirección datospersonaleshnk@heineken.com
					manifestando tu negativa a dichas finalidades, lo anterior, en el
					entendido que la negativa al uso de tus Datos Personales para las
					finalidades no necesarias, no será motivo para que te neguemos
					cualquiera de nuestros productos o servicios.
				</p>
				<p>
					SUMA SIX realiza el Tratamiento de Datos Personales de los Titulares
					sólo en el tiempo en el cual los mismos estén vigentes y/o el
					Tratamiento sea necesario para dar cumplimiento a las propias
					finalidades de SUMA SIX y/o a una obligación legal.
				</p>
				<p>
					2. <br /> Tipos de Datos Personales sujetos a Tratamiento.
				</p>
				<p>
					Para llevar a cabo las finalidades descritas en el presente Aviso de
					Privacidad, recabaremos y Trataremos tus Datos Personales
					pertenecientes a las siguientes categorías, según sea necesario:
				</p>
				<p>
					- <br /> Datos de identificación y de contacto: nombre, apellido,
					fecha de nacimiento, correo electrónico, número de teléfono.
				</p>
				<p>
					Adicionalmente, recolectamos información acerca de cómo utilizas
					nuestros productos, servicios y páginas de Internet, plataformas y
					aplicaciones oficiales, tales como dirección IP, cookies, ID de
					dispositivo móvil, datos de acceso (login), historial de navegación,
					tipo y versión de navegador, clicks, configuración de zona horaria y
					ubicación, páginas visitadas (incluyendo registro de fecha y hora),
					tipos y versiones de plug-ins en tu navegador, sistemas operativos,
					plataformas e información de otras tecnologías de los dispositivos que
					utilizas para ingresar a nuestras páginas web, plataformas y
					aplicaciones oficiales.
				</p>
				<p>
					Lo anterior, incluyendo aquella información que compartas a SUMA SIX a
					través de cualquiera de tus redes sociales, en caso de que las
					utilices como medio de registro en nuestras páginas web, aplicaciones
					y plataformas oficiales.
				</p>
				<p>
					Asimismo, recabamos, utilizamos y compartimos Datos Personales
					Disociados (los “Datos Personales Disociados”), tales como información
					estadística y demográfica, con el objetivo de dar cumplimiento a
					cualquiera de las finalidades señaladas en el presente Aviso. Los
					Datos Personales Disociados pueden derivarse de ciertos Datos
					Personales, pero no son considerados como tal bajo la regulación
					aplicable, ya que no pueden asociarse al Titular ni permiten su
					identificación, por su estructura, contenido o grado de desagregación.
					Sin embargo, si combinamos o relacionamos los Datos Personales
					Disociados con tus Datos Personales, al nivel de que dichos datos
					disociados pudieran identificarte directa o indirectamente, la
					información combinada será considerada por nosotros como parte de tus
					Datos Personales y, por lo tanto, se les dará un tratamiento basado en
					el presente Aviso de Privacidad.
				</p>
				<p>
					En caso de que proporciones a SUMA SIX Datos Personales distintos de
					los señalados en el presente Aviso, y si dichos Datos son
					proporcionales a las finalidades contenidas en este Aviso, SUMA SIX
					podrá realizar el Tratamiento de los Datos en cuestión, única y
					exclusivamente para dar cumplimiento a las citadas finalidades,
					entendiéndose la entrega de los citados Datos como tu consentimiento
					para que realicemos un Tratamiento.
				</p>
				<p>
					3. <br /> Medios a través de los cuales obtenemos tus datos
					personales.
				</p>
				<p>
					Obtenemos tus Datos Personales de manera directa, cuando los mismos
					nos los proporciones de manera personal de forma presencial o a través
					de medios electrónicos, tales como correo electrónico, nuestras
					páginas oficiales de Internet, aplicaciones, plataformas y/o redes
					sociales oficiales, o vía telefónica; o de manera indirecta, cuando
					los Datos Personales los recibamos de un tercero o de alguna
					plataforma de redes sociales o medios de comunicación.
				</p>
				<p>
					SUMA SIX podrá recabar los Datos Personales al inicio de la relación
					jurídica o comercial con el Titular o bien, durante la vigencia y
					desarrollo de la misma. Cualquier Dato Personal que SUMA SIX recabe
					durante el desarrollo de la relación jurídica o comercial con el
					Titular, será sujeto de Tratamiento conforme a lo señalado en el
					presente Aviso de Privacidad.
				</p>
				<p>
					4. <br /> Quién tiene acceso a tus Datos Personales.
				</p>
				<p>
					El personal de SUMA SIX sólo tendrá acceso a tus Datos Personales
					cuando sea necesario para desempeñar su trabajo o para cumplir con
					cualquiera de las finalidades descritas en el presente Aviso.
				</p>
				<p>
					Es probable que necesitemos compartir tus Datos Personales con
					terceros a fin de dar cumplimiento a cualquiera de las finalidades
					señaladas en el presente Aviso. Estos terceros son:
				</p>
				<p>
					- <br /> Empresas del grupo Heineken, con el propósito de brindar de
					forma central diversos procesos y servicios, derivado de la naturaleza
					nacional e internacional de los sistemas de tecnología de información
					que se comparten dentro del grupo Heineken;
				</p>
				<p>
					- <br /> Terceros proveedores de productos o servicios. Estos
					productos o servicios pueden incluir servicios de mercadotecnia,
					publicidad, plataformas de servicios de mercadotecnia, estrategias de
					marketing digital, elaboración y diseño de concursos, rifas y sorteos,
					y de sistemas de tecnología de información;
				</p>
				<p>
					- <br /> Consultores profesionales, tales como contadores, auditores o
					abogados;
				</p>
				<p>
					- <br /> En caso de que vendamos a algún tercero la totalidad o parte
					de los activos o acciones de una compañía perteneciente al grupo
					Heineken, a la cual anteriormente se le habían compartido tus Datos
					Personales, dichos Datos podrían llegar a ser compartidos con el
					citado tercero;
				</p>
				<p>
					- <br /> Autoridades gubernamentales, a fin de dar cumplimiento a
					cualquier obligación legal o judicial.
				</p>
				<p>
					Los terceros mencionados anteriormente pueden estar ubicados en
					México, en países de la Unión Europea o en cualquier otra parte del
					mundo. Cuando tus Datos Personales sean resguardados fuera de México o
					de la Unión Europea, nos aseguraremos que los mismos tengan un nivel
					adecuado de protección. Exigimos a nuestros proveedores de servicios o
					productos y consultores profesionales que establezcan y mantengan
					medidas de seguridad apropiadas para mantener la seguridad y
					confidencialidad de tus Datos Personales, mediante estrictos
					estándares y acuerdos legales. En caso de que la transmisión de los
					Datos se realice a un receptor en un país que tenga un régimen
					distinto en materia de protección de datos personales, nos
					aseguraremos que esta transmisión internacional de datos no afecte de
					una forma negativa el nivel de protección de tus Datos Personales y se
					encuentre basada en medidas apropiadas de seguridad, tales como
					cláusulas estándar o reglas corporativas vinculantes. Puedes solicitar
					información sobre las medidas de seguridad que utilizamos a través del
					medio de contacto señalado más adelante en el numeral 9 del presente
					Aviso.
				</p>
				<p>
					5. <br /> Seguridad.
				</p>
				<p>
					Estableceremos y mantendremos medidas de seguridad administrativas,
					técnicas y físicas con el fin de proteger tus Datos Personales contra
					daño, pérdida, alteración, destrucción o el uso, acceso o tratamiento
					no autorizado, tomando en cuenta los posibles riesgos. Estas medidas
					en todo momento estarán alineadas a los estándares legales y de la
					industria.
				</p>
				<p>
					6. <br /> Plazos por los cuales conservamos tus Datos Personales.
				</p>
				<p>
					Conservaremos tus Datos Personales por el tiempo que nos sea
					legalmente permitido, mientras sean necesarios para dar cumplimiento a
					alguna de las finalidades establecidas en el presente Aviso o a algún
					requerimiento u obligación legal que nos sea aplicable, o bien,
					mientras sea permitido en atención a cualquier plazo de prescripción
					legal. Tomaremos las medidas necesarias para destruir o disociar los
					Datos Personales que estén en nuestra posesión cuando ya no sean
					necesarios para cumplir con las finalidades previstas anteriormente o
					una vez concluidos los plazos de retención.
				</p>
				<p>
					7. <br /> Tratamiento de Datos Personales de un Tercero Relacionado.
				</p>
				<p>
					En caso de que, con motivo de dar cumplimiento a las finalidades
					señaladas anteriormente, SUMA SIX realice el Tratamiento de los Datos
					Personales de terceros relacionados contigo (tales como pareja o
					cónyuge, hijos, dependientes y/o referencias personales; cada uno de
					ellos un “Tercero Relacionado”), tienes la obligación de compartir el
					contenido del presente Aviso de Privacidad con dicho Tercero
					Relacionado y de obtener su consentimiento para que SUMA SIX pueda
					realizar el Tratamiento y hacer uso (incluyendo transmisión y
					revelación) de sus Datos Personales, de acuerdo a las finalidades
					previstas en el presente Aviso.
				</p>
				<p>
					En caso de que nos proporciones Datos Personales de un Tercero
					Relacionado, implica que tienes su consentimiento y has puesto a su
					disposición el presente Aviso de Privacidad en términos de lo señalado
					anteriormente, por lo que es tu obligación sacar en paz y a salvo a
					SUMA SIX de toda responsabilidad que derive de cualquier queja o
					reclamación que llegase a imponer dicho Tercero Relacionado en nuestra
					contra.
				</p>
				<p>
					8. <br /> Tratamiento de Datos Personales de menores de edad.
				</p>
				<p>
					Nuestros sitios web, plataformas y aplicaciones oficiales no están
					diseñados para ser utilizados por personas menores de edad, por lo que
					no recolectamos Datos Personales si tenemos conocimiento que sus
					titulares son menores de 18 años.
				</p>
				<p>
					Si eres es el padre, madre o tutor legal de algún menor de edad o de
					alguna persona en estado de interdicción o situación de discapacidad,
					de acuerdo a la ley aplicable, que haya proporcionado sus datos
					personales sin su consentimiento, puedes solicitar que dichos datos
					sean cancelados de conformidad con el procedimiento contenido en el
					presente aviso de privacidad.
				</p>
				<p>
					9. <br /> Acceso, rectificación, cancelación, oposición, preguntas y
					quejas.
				</p>
				<p>
					Mantén tus Datos Personales actualizados e infórmanos de cualquier
					cambio significativo en tus Datos o de tus Terceros Relacionados
					mediante un correo electrónico a la dirección señalada más adelante en
					este numeral.
				</p>
				<p>
					Tienes el derecho de solicitar acceso a tus Datos Personales que sean
					objeto de Tratamiento por parte de SUMA SIX o de algún tercero en su
					representación y conocer los detalles de dicho Tratamiento. Asimismo,
					tienes derecho a rectificar, cancelar, eliminar o restringir (según
					corresponda) o a oponerte al Tratamiento de tus datos, siempre en
					atención al contenido de la Ley, otras regulaciones y leyes
					aplicables, y a los lineamientos internos de SUMA SIX. Tienes el
					derecho de recibir un resumen de los Datos Personales que nos hayas
					proporcionado, en un formato organizado, de uso común y apto para
					leerse mediante un equipo de cómputo común. En algunos casos podemos
					aceptar transferir tus Datos Personales a otro Responsable, previa
					solicitud que nos hagas por escrito para tales efectos, siempre que
					sea técnicamente posible. Igualmente, SUMA SIX reconoce tu derecho
					para limitar el uso o divulgación de tus Datos Personales y para
					manifestar tu negativa al Tratamiento de tus Datos Personales para
					aquellas finalidades que no sean necesarias.
				</p>
				<p>
					Si deseas limitar el uso o divulgación de tus Datos Personales, te
					recordamos que tienes a tu disposición los siguientes medios:
				</p>
				<p>
					(i) <br /> Inscripción en el Registro Público de Usuarios (REUS), a
					cargo de la Comisión Nacional para la Protección y Defensa de los
					Usuarios de Servicios Financieros (CONDUSEF);
				</p>
				<p>
					(ii) <br /> Inscripción en el Registro Público para Evitar Publicidad
					(REPEP), a cargo de la Procuraduría Federal del Consumidor (PROFECO);
					y/o
				</p>
				<p>
					(iii) <br /> Enviarnos un correo electrónico a la dirección
					datospersonaleshnk@heineken.com manifestándonos tu negativa pare
					seguir recibiendo comunicados o promociones de nuestra parte.
				</p>
				<p>
					Asimismo, tienes el derecho de solicitarnos que dejemos de Tratar tus
					Datos Personales, lo cual no sería aplicable en los casos que
					tuviéramos razones legítimas u obligaciones legales para realizar el
					Tratamiento, en dicho caso, continuaremos Tratando tus Datos
					Personales. En los casos donde nos otorgues tu consentimiento para el
					Tratamiento de tus Datos Personales, tienes el derecho de revocar el
					mismo sin que esto afecte la legalidad del Tratamiento que hayamos
					realizado hasta antes de dicho momento.
				</p>
				<p>
					Toma en cuenta que revocar o limitar tu consentimiento al Tratamiento
					de tus Datos Personales puede llegar a afectar o limitar tu relación
					con SUMA SIX.
				</p>
				<p>
					Para ejercer cualquiera de los derechos mencionados anteriormente,
					deberás enviar tu solicitud directamente a la cuenta de correo
					electrónico datospersonaleshnk@heineken.com. Dicha solicitud deberá
					contener: nombre y domicilio u otro medio para comunicarte la
					respuesta a su solicitud; los documentos que acrediten tu identidad o,
					en su caso, la representación legal; y la descripción clara y precisa
					de los datos personales respecto de los cuales se está ejerciendo el
					derecho en cuestión.
					<br />
					SUMA SIX te comunicará, a través de los medios de contacto que
					proporciones en tu solicitud, si la misma fue procedente, en un plazo
					máximo de 20 días hábiles contados desde la fecha en la que se recibió
					la solicitud correspondiente.
				</p>
				<p>
					10. <br /> Uso de tecnología “Cookie” y “Device ID” en nuestras
					plataformas, aplicaciones y sitios web oficiales.
				</p>
				<p>
					Los sitios web, plataformas y aplicaciones oficiales de SUMA SIX hacen
					uso de los archivos denominados “cookies”. Las “cookies” son pequeños
					archivos de texto que cada sitio web, plataforma y aplicación almacena
					localmente en tu equipo de cómputo o dispositivo electrónico.
				</p>
				<p>
					Las “cookies” y tecnologías similares, en ocasiones son necesarios
					para recordar la configuración de tu cuenta, idioma y país en el que
					te encuentras, pero también nos permiten medir y analizar tu
					comportamiento en nuestra página web, aplicaciones y plataformas
					oficiales, así como para mostrarte publicidad personalizada en
					nuestras páginas de Internet, plataformas y aplicaciones oficiales o
					en sitios de terceros. Solicitaremos tu consentimiento para el uso de
					las “cookies” cuando así sea requerido por la regulación aplicable.
				</p>
				<p>
					Una vez que nos hayas dado tu consentimiento para el uso de “cookies”
					o al ingresar algún sitio web, plataforma y aplicación de SUMA SIX,
					almacenaremos una “cookie” en tu dispositivo móvil para recordar esto
					para la próxima vez. Si deseas retirar tu consentimiento del uso de
					nuestras “cookies”, puedes hacerlo en el momento que lo desees; podrás
					eliminar nuestras “cookies” modificando la configuración de tu
					navegador de Internet. Debes hacer esto modificando la configuración
					de cada navegador que utilices. Toma en cuenta que algunos de nuestros
					servicios no funcionarán si tu navegador no acepta “cookies”. Sin
					embargo, puedes permitir “cookies” de sitios web específicos
					marcándolos como &quot;sitios web de confianza&quot; en tu navegador
					de Internet.
				</p>
				<p>
					Los siguientes enlaces pueden ayudarte a administrar tu configuración
					de “cookies”, o puedes usar la opción &apos;Ayuda&apos; en tu
					navegador de Internet para obtener más detalles:
				</p>
				<p>
					Para Internet Explorer:
					https://support.microsoft.com/en-us/help/17442/windows-internetexplorer-delete-manage-cookies
				</p>
				<p>Para Mozilla Firefox: http://support.mozilla.com/en-US/kb/Cookies</p>
				<p>
					Para Google Crome:
					http://www.google.com/support/chrome/bin/answer.py?hl=es&answer=95647
				</p>
				<p>Safari: http://support.apple.com/kb/PH5042</p>
				<p>Opera: http://www.opera.com/help/tutorials/security/privacy/</p>
				<p>
					Adobe (cookies flash):
					https://www.adobe.com/support/flash/downloads.html
				</p>
				<p>
					Para bloquear específicamente las “cookies” de Google Analytics,
					puedes instalar el &quot;Google Analytics Opt-out Browser Add-on&quot;
					(complemento del navegador de exclusión de Google Analytics)
					proporcionado por Google.
				</p>
				<p>
					Ten en cuenta que, con el uso de la configuración de “cookies” en
					nuestro sitio web, plataformas y aplicaciones oficiales no se
					eliminarán “cookies” que ya se hayan configurado anteriormente. Si
					deseas hacerlo, puedes realizarlo reconfigurando tu navegador web como
					se describe arriba, después de haber cambiado la Configuración de
					“cookies” de nuestro sitio web, plataformas y aplicaciones oficiales.
				</p>
				<p>
					Adicionalmente, si ingresas mediante un dispositivo móvil a cualquiera
					de nuestras plataformas, aplicaciones y/o páginas de Internet
					oficiales, tendremos acceso al identificador alfanumérico único
					asignado a dicho dispositivo (este identificador también es conocido
					como “Device ID” o “Identificador Móvil”). Mediante este identificador
					podemos analizar y seguir el uso, ubicación y comportamiento en línea
					de dicho dispositivo, sin embargo, SUMA SIX lo utiliza únicamente para
					fines de publicidad y mercadotecnia. Si deseas no otorgarnos —o dejar
					de otorgarnos— acceso a dicho identificador, puedes hacerlo en
					cualquier momento directamente desde la configuración del dispositivo
					móvil en cuestión.
				</p>
				<p>
					11. <br /> Modificaciones al Aviso.
				</p>
				<p>
					El presente Aviso de privacidad puede sufrir modificaciones, cambios o
					actualizaciones derivadas de nuevos requerimientos legales y nuestras
					prácticas de privacidad, de nuestras propias necesidades por los
					productos o servicios que ofrecemos o por cualquier otra causa.
				</p>
				<p>
					SUMA SIX se compromete a mantenerte informado sobre los cambios que
					pueda sufrir el presente Aviso, lo cual se notificará publicando una
					nota visible en esta página de Internet y/o en cualquier otra página,
					plataforma y/o aplicación oficial de SUMA SIX; asimismo, cualquier
					interesado podrá solicitar, mediante un correo electrónico a la
					dirección señalada en el punto anterior, que se le envíe el Aviso de
					Privacidad vigente. SUMA SIX no será responsable si un Titular no
					recibe la notificación de cambio en el Aviso si existiere algún
					problema con su cuenta de correo electrónico, de transmisión de datos
					por Internet o si no se tuvo acceso a la página de Internet,
					plataforma o aplicación mencionada anteriormente por cualquier causa
					no imputable a SUMA SIX.
				</p>
				<p>
					12. <br /> Contacto
				</p>
				<p>
					Si deseas ejercer cualquiera de tus derechos, tienes alguna queja
					sobre la forma en la que tus Datos Personales son Tratados o sobre
					nuestras prácticas en materia de privacidad y protección de datos
					personales, puedes contactarnos mediante la dirección de correo
					electrónico datospersonaleshnk@heineken.com. Asimismo, te recordamos
					el derecho que te asiste para acudir ante el Instituto Nacional de
					Transparencia, Acceso a la Información y Protección de Datos
					Personales (INAI) en caso de considerar que tu derecho a la protección
					de Datos Personales ha sido vulnerado o si presumes alguna violación a
					las disposiciones previstas en la Ley. Para mayor información, te
					sugerimos visitar su página oficial de Internet www.inai.org.mx.
				</p>
				<button
					className='btn-primary mx-auto mt-8 !px-8'
					onClick={() => {
						window.scrollTo(0, 0);
					}}>
					Ir arriba
				</button>
			</section>
		</>
	);
}

const mapStateToProps = (state: StateModel) => ({
	client: state.client,
});

export default connect(mapStateToProps)(Aviso);
